import React from "react";
import { Container, Breadcrumb } from "react-bootstrap";
// import "./AboutBreadcrumb.css";

const ContactBreadcrumb = () => {
    return (
        <div className="about-breadcrumb-section ">
            <Container className="heading-title">
                <h2 className="about-title text-center">
                    Contact
                    <span className=" about-text"> Us</span>
                </h2>
                <Breadcrumb>
                    <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                    <Breadcrumb.Item href="#">Pages</Breadcrumb.Item>
                    <Breadcrumb.Item active className="about-text">Contact Us</Breadcrumb.Item>
                </Breadcrumb>
            </Container>
        </div>
    );
};

export default ContactBreadcrumb;
